import { render } from "./TrainerLayout.vue?vue&type=template&id=d1ab5c10&scoped=true"
const script = {}

import "./TrainerLayout.vue?vue&type=style&index=0&id=d1ab5c10&lang=scss&scoped=true"

import exportComponent from "/Users/chronosme/Domains/mathgs2.mu/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d1ab5c10"]])

export default __exports__